/* eslint-disable @typescript-eslint/no-explicit-any */

import type { AnyEventBase } from '@snapchat/blizzard-schema';

/**
 * Serialize the provided data as JSON. BigInt values are serialized as quoted numbers and nulls are
 * omitted. Nested objects are flattened.
 *
 * @internal
 */
export function stringifyBlizzardJsonArray(data: AnyEventBase[]): string {
  return JSON.stringify(transformForBlizzard(data));
}

/**
 * Serialize the provided data as JSON. BigInt values are serialized as quoted numbers and nulls are
 * omitted. Nested objects are flattened.
 */
export function stringifyBlizzardJson(data: AnyEventBase): string {
  return JSON.stringify(transformForBlizzard(data));
}

/** Transform the provided value to a format suitable for serialization to JSON for Blizzard. */
function transformForBlizzard(value: unknown): unknown {
  if (typeof value === 'bigint') {
    // serialize bigints as quoted numbers (collector supports this for numeric fields)
    // TODO: evaluate migrating to fast-json-stringify when they natively support bigint:
    // https://github.com/fastify/fast-json-stringify/issues/491
    return value.toString();
  }
  if (Array.isArray(value)) {
    // recurse over arrays
    return value.map(it => transformForBlizzard(it));
  }
  if (typeof value === 'object' && value !== null) {
    // flatten/transform objects

    const transformed: { [key: string]: unknown } = {};
    for (const [key, objValue] of Object.entries(value)) {
      if (objValue !== null) {
        // omit nulls from objects

        if (typeof objValue === 'object' && !Array.isArray(objValue)) {
          // flatten nested objects
          Object.assign(transformed, transformForBlizzard(objValue));
        } else {
          // otherwise transform values
          transformed[key] = transformForBlizzard(objValue);
        }
      }
    }
    return transformed;
  }

  return value;
}
